import type { MaterialsItem } from "@/lib/materials-api";

/** 外链视频素材（腾讯/B 站等嵌入，非本地上传文件）。 */
export function isExternalVideoItem(item: MaterialsItem): boolean {
  return item.source_kind === "external_video";
}

export function externalVideoEmbedUrl(item: MaterialsItem): string | null {
  const url = item.external_embed_url?.trim();
  return url || null;
}

/** 生成写入品牌站页面的响应式 iframe 片段（固定属性，禁止用户自定义）。 */
export function buildExternalVideoEmbedHtml(embedUrl: string, materialSlug?: string): string {
  const slugAttr = materialSlug
    ? ` data-c456-material-slug="${materialSlug.replace(/"/g, "")}"`
    : "";
  return `<div class="c456-video-embed" style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden;max-width:100%;"${slugAttr}><iframe src="${embedUrl}" style="position:absolute;top:0;left:0;width:100%;height:100%;border:0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" loading="lazy" allowfullscreen></iframe></div>`;
}

/** 在 </body> 前插入 HTML 片段；无 body 则追加到末尾。 */
export function appendHtmlBeforeBodyClose(html: string, snippet: string): string {
  const lower = html.toLowerCase();
  const idx = lower.lastIndexOf("</body>");
  if (idx >= 0) {
    return `${html.slice(0, idx)}\n${snippet}\n${html.slice(idx)}`;
  }
  const trimmed = html.trimEnd();
  return trimmed ? `${trimmed}\n${snippet}` : snippet;
}
